<template>
  <v-container id="resetpassword" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="accent" light max-width="100%" width="600" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Reset Your Password</h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <validation-observer v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(validateForm)">
                <validation-provider v-slot="{ errors }" name="email" rules="required|email">
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    color="secondary"
                    type="email"
                    label="Email..."
                    prepend-icon="mdi-email"
                    class="mt-10"
                  />
                </validation-provider>

                <v-btn
                  color="primary"
                  default
                  block
                  rounded
                  large
                  class="text-capitalize font-weight-bold"
                  type="submit"
                  :disabled="loading"
                  :loading="loading"
                >Request Password Reset!</v-btn>
              </form>
            </validation-observer>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <v-row no-gutters>
      <v-col sm="12" md="4" offset-md="4" class="my-4">
        <v-alert
          :value="showError"
          border="right"
          outlined
          type="error"
          elevation="2"
        >{{message}}</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagesResetPassword",

  components: {
    // PagesBtn: () => import("./components/Btn")
  },
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    email: "",
    show: false,
    loading: false,
    message: null
  }),
  computed: {
    showError() {
      return this.message !== null && this.message.length > 0;
    }
  },
  methods: {
    clearForm() {
      this.$v.$reset();
      this.email = null;
    },
    validateForm(scope) {
      this.loading = true;
      this.message = null;

      this.$store
        .dispatch("authenticationService/resetPassword", {
          email: this.email
        })
        .then(() => {
          this.loading = false;
          this.clearForm();
          this.message = "Please check your email for further instructions on how to reset your password."
        })
        .catch(error => {
          this.loading = false;
          this.message = error.message;
        });
    }
  }
};
</script>
